import {exportToWAV} from 'api/exportToWav.js';
var Flac = require('libflacjs/dist/libflac.js');

export const decodeFlac = async (flacData) => {
    var VERIFY = true,
        USE_OGG = true;


    ////////
    // [1] CREATE -> IN: config { ... } (decoding parameters)
    
    //overwrite default configuration from config object
    VERIFY = false;

    //decode from native FLAC container or from OGG container
    USE_OGG = false;

    // create decoder
    var flac_decoder = Flac.create_libflac_decoder(VERIFY);

    if (flac_decoder == 0){
        return;
    }


    ////////
    // [2] INIT -> OUT: decBuffer (decoded data), metaData (OPTIONALLY, FLAC metadata)
    //             IN: flacData Uint8Array (FLAC data)

    // [2] (a) setup reading input data
    var currentDataOffset = 0;
    var size = flacData.buffer.byteLength;

    //function that will be called for reading the input (FLAC) data:
    function read_callback_fn(bufferSize){

        var end = currentDataOffset === size? -1 : Math.min(currentDataOffset + bufferSize, size);

        var _buffer;
        var numberOfReadBytes;
        if(end !== -1){

            _buffer = flacData.subarray(currentDataOffset, end);
            numberOfReadBytes = end - currentDataOffset;

            currentDataOffset = end;
        } else {
            //nothing left to read: return zero read bytes (indicates end-of-stream)
            numberOfReadBytes = 0;
        }

        return {buffer: _buffer, readDataLength: numberOfReadBytes, error: false};
    }


    // [2] (b) setup writing (decoded) output data

    //for "buffering" the decoded data:
    var decBuffer = [];
    //for storing the decoded FLAC metadata
    var metaData;

    //function that will be called for decoded output data (WAV audio)
    function write_callback_fn(channelsBuffer, frameHeader){
        // channelsBuffer is an Array of the decoded audio data (Uint8Array):
        // the length of array corresponds to the channels, i.e. there is an Uint8Array for each channel

        // frameHeader -> [example] {
        //   bitsPerSample: 8
        //   blocksize: 4096
        //   channelAssignment: 0
        //   channels: 2
        //   crc: 0
        //   number: 204800
        //   numberType: "samples"
        //   sampleRate: 44100
        //   subframes: undefined // -> needs to be enabled via
        //                       //     Flac.setOptions(flac_decoder, {analyseSubframes: true})
        //                       // -> see API documentation
        //}

        decBuffer.push(channelsBuffer);
    }

    // [2] (c) optional callbacks for receiving details about errors and/or metadata

    function error_callback_fn(err, errMsg, client_data){
        console.error('decode error callback', err, errMsg);
    }

    function metadata_callback_fn(data){
        // data -> [example] {
        //  min_blocksize: 4096,
        //  max_blocksize: 4096,
        //  min_framesize: 14,
        //  max_framesize: 5408,
        //  sampleRate: 44100,
        //  channels: 2,
        //  bitsPerSample: 16,
        //  total_samples: 267776,
        //  md5sum: "50d4d469448e5ea75eb44ab6b7f111f4"
        //}
        console.info('meta data: ', data);
        metaData = data;
    }

    // [2] (d) intialize for reading from native-FLAC or from OGG container
    var flac_ok = 1;
    var status_decoder;
    if(!USE_OGG){
        // decode from native FLAC container
        status_decoder = Flac.init_decoder_stream(
            flac_decoder,
            read_callback_fn, write_callback_fn,     //required callback(s)
            error_callback_fn, metadata_callback_fn  //optional callback(s)
        );
    } else {
        // decode from OGG container
        status_decoder = Flac.init_decoder_ogg_stream(
            flac_decoder,
            read_callback_fn, write_callback_fn,     //required callback(s)
            error_callback_fn, metadata_callback_fn  //optional callback(s)
        );
    }
    flac_ok &= status_decoder == 0;

    if(flac_ok != 1){
        return;
    }

    ////////
    // [3] DECODE -> IN: FLAC audio data (see above, the read-callack)
    // ... repeat encoding step [3] as often as necessary

    // example for chunk-by-chunk (stream mode) or all-at-once decoding (file mode)
    var mode = 'file'; //'stream';// 'stream' | 'file'

    var state = 0;
    var flac_return = 1;

    if(mode == 'stream'){

        // VARIANT 1: decode chunks of flac data, one-by-one

        //request to decode data chunks until end-of-stream is reached:
        while(state <= 3 && flac_return != false){

            flac_return &= Flac.FLAC__stream_decoder_process_single(flac_decoder);
            state = Flac.FLAC__stream_decoder_get_state(flac_decoder);
        }

        flac_ok &= flac_return != false;

    } else if(mode == 'file'){

        // VARIANT 2: decode complete data stream, all-at-once
        flac_return &= Flac.FLAC__stream_decoder_process_until_end_of_stream(flac_decoder);

        //optionally: retrieve status
        state = Flac.FLAC__stream_decoder_get_state(flac_decoder);
    }


    if (flac_return != true){
        return;
    }

    ////////
    // [4] FINISH DECODING

    // finish Decoding
    flac_ok &= Flac.FLAC__stream_decoder_finish(flac_decoder);

    ////////
    // [5] DESTROY: delete dencoder
    // alternatively reset the decoder, and then re-initialize for re-using the decoder instance

    //after usage: free up all resources for the decoder
    Flac.FLAC__stream_decoder_delete(flac_decoder);
    let blob = exportWavFile(decBuffer, metaData.sampleRate, metaData.channels, metaData.bitsPerSample);
    return blob.arrayBuffer();
};

function exportWavFile(recBuffers, sampleRate, channels, bitsPerSample) {
    //convert buffers into one single buffer
    const samples = interleave(recBuffers, channels, bitsPerSample);
    const dataView = encodeWAV(samples, sampleRate, channels, bitsPerSample);
    return new Blob([dataView], { type: 'audio/wav' });
}

function interleave(recBuffers, channels, bitsPerSample) {
    let byteLen = bitsPerSample / 8;
    //NOTE 24-bit samples are padded with 1 byte
    const pad8 = (bitsPerSample === 24 || bitsPerSample === 8) ? 1 : 0;
    if (pad8) {
        byteLen += pad8;
    }
    //calculate total length for interleaved data
    let dataLength = 0;
    for (let i = 0; i < channels; ++i) {
        dataLength += getLengthFor(recBuffers, i, byteLen, pad8);
    }
    const result = new Uint8Array(dataLength);
    let buff, buffLen = 0, index = 0, inputIndex = 0, ch_i = 0, b_i = 0, pad_i = false, ord = false;
    for (let arrNum = 0, arrCount = recBuffers.length; arrNum < arrCount; ++arrNum) {
        //for each buffer (i.e. array of Uint8Arrays):
        buff = recBuffers[arrNum];
        buffLen = buff[0].length;
        inputIndex = 0;
        pad_i = false;
        ord = false;
        //interate over buffer
        while (inputIndex < buffLen) {
            //write channel data
            for (ch_i = 0; ch_i < channels; ++ch_i) {
                //write sample-length
                for (b_i = 0; b_i < byteLen; ++b_i) {
                    // write data & update target-index
                    if (pad8) {
                        pad_i = pad8 && (b_i === byteLen - pad8);
                        if (pad_i) {
                            if (buff[ch_i][inputIndex + b_i] !== 0 && buff[ch_i][inputIndex + b_i] !== 255) {
                                console.error('[ERROR] mis-aligned padding: ignoring non-padding value (padding should be 0 or 255) at ' + (inputIndex + b_i) + ' -> ', buff[ch_i][inputIndex + b_i]);
                            }
                        }
                        else {
                            if (bitsPerSample === 8) {
                                ord = buff[ch_i][inputIndex + b_i + 1] === 0;
                                result[index++] = ord ? buff[ch_i][inputIndex + b_i] | 128 : buff[ch_i][inputIndex + b_i] & 127;
                            }
                            else {
                                result[index++] = buff[ch_i][inputIndex + b_i];
                            }
                        }
                    }
                    else {
                        result[index++] = buff[ch_i][inputIndex + b_i];
                    }
                }
            }
            //update source-index
            inputIndex += byteLen;
        }
    }
    return result;
}

function getLengthFor(recBuffers, index, sampleBytes, bytePadding) {
    var recLength = 0, blen;
    var decrFac = bytePadding > 0 ? bytePadding / sampleBytes : 0; //<- factor do decrease size in case of padding bytes
    for (var i = recBuffers.length - 1; i >= 0; --i) {
        blen = recBuffers[i][index].byteLength;
        if (bytePadding > 0) {
            recLength += blen - (decrFac * blen);
        }
        else {
            recLength += blen;
        }
    }
    return recLength;
}

function encodeWAV(samples, sampleRate, channels, bitsPerSample) {
    var bytePerSample = bitsPerSample / 8;
    var length = samples.length * samples.BYTES_PER_ELEMENT;
    var buffer = new ArrayBuffer(44 + length);
    var view = new DataView(buffer);
    /* RIFF identifier */
    writeString(view, 0, 'RIFF');
    /* file length */
    view.setUint32(4, 36 + length, true);
    /* RIFF type */
    writeString(view, 8, 'WAVE');
    /* format chunk identifier */
    writeString(view, 12, 'fmt ');
    /* format chunk length */
    view.setUint32(16, 16, true);
    /* sample format (raw) */
    view.setUint16(20, 1, true);
    /* channel count */
    view.setUint16(22, channels, true);
    /* sample rate */
    view.setUint32(24, sampleRate, true);
    /* byte rate (sample rate * block align) */
    view.setUint32(28, sampleRate * channels * bytePerSample, true);
    /* block align (channel count * bytes per sample) */
    view.setUint16(32, channels * bytePerSample, true);
    /* bits per sample */
    view.setUint16(34, bitsPerSample, true);
    /* data chunk identifier */
    writeString(view, 36, 'data');
    /* data chunk length */
    view.setUint32(40, length, true);
    writeData(view, 44, samples);
    return view;
}

function writeString(view, offset, str) {
    for (var i = 0; i < str.length; i++) {
        view.setUint8(offset + i, str.charCodeAt(i));
    }
}

function writeData(view, offset, input) {
    for (var i = 0; i < input.length; ++i, ++offset) {
        view.setUint8(offset, input[i]);
    }
}
